var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1810156,18.6890625 L7.76203125,21.1080469 L6.67875,20.0247656 C6.44988281,19.7960156 6.07898437,19.7960156 5.85005859,20.0247656 L0.790605469,25.0842188 C-0.263613281,26.1384375 -0.263613281,27.8538867 0.790605469,28.9081055 C1.31771484,29.4352148 2.01017578,29.6987695 2.70251953,29.6987695 C3.39492187,29.6987695 4.08738281,29.4352148 4.61449219,28.9081055 L9.67394531,23.8486523 C9.90275391,23.6198438 9.90275391,23.2488281 9.67394531,23.0199609 L8.59066406,21.9366797 L11.0096484,19.5176953 C11.238457,19.2888867 11.238457,18.9178711 11.0096484,18.6890039 C10.7807812,18.4603125 10.4098828,18.4603125 10.1810156,18.6890625 L10.1810156,18.6890625 Z M3.78585937,28.0794141 C3.18861328,28.6767188 2.21660156,28.6768359 1.61929687,28.0794141 C1.02199219,27.4821094 1.02199219,26.5102148 1.61929687,25.9128516 L6.264375,21.2677734 L8.4309375,23.4343359 L3.78585937,28.0794141 Z",
    id: "icon-search-path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.398418,3.49980469 C15.7320117,-1.16660156 8.16626953,-1.16660156 3.49980469,3.49980469 C-1.16660156,8.16621094 -1.16660156,15.7319531 3.49980469,20.398418 C8.16621094,25.0648828 15.7319531,25.0648242 20.398418,20.398418 C25.0648828,15.7320117 25.0648828,8.16621094 20.398418,3.49980469 Z M17.9109375,17.9108789 C14.6183203,21.2034961 9.27996094,21.2034961 5.98740234,17.9108789 C2.69478516,14.6182617 2.69478516,9.27990234 5.98740234,5.98734375 C9.28001953,2.69472656 14.6183789,2.69472656 17.9109375,5.98734375 C21.2034961,9.27990234 21.2034961,14.6183203 17.9109375,17.9108789 Z",
    id: "icon-search-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-search-\\uD83D\\uDE80-UiKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-search-Icons",
    transform: "translate(-482.000000, -102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-search-icon_search",
    transform: "translate(482.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-search-Mask",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-search-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-search-Body",
    transform: "translate(0.000000, 0.300000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-search-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-search-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon-search-Mask",
    fill: "#020288",
    fillRule: "nonzero",
    xlinkHref: "#icon-search-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-search-Group",
    mask: "url(#icon-search-mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-search-Color-hand"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-search-Color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icon-search-Circle",
    transform: "translate(6.100488, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-search-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-search-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon-search-Mask",
    fill: "#E2C4FF",
    fillRule: "nonzero",
    xlinkHref: "#icon-search-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-search-Group",
    mask: "url(#icon-search-mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.100488, 0.000000)",
    id: "icon-search-Color-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "icon-search-Color",
    className: "main-color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_search.89c409b4.svg";
export { ForwardRef as ReactComponent };